import React, { useState } from "react";
import Stepper from "../components/Stepper";
import { FORM_FIELDS } from "../Constants";
import StoresPreveiwList from "./store-data/StoresPreveiwList";
import { tenantService } from "../../../Services";
import ResultModal from "../../Common/ResultModal";
import { convertToDecimalString } from "../../../Helpers/DecimalNumberHelper";

const DataVerification = ({
  stepState,
  previousPage,
  nextPage,
  formData,
  resetData,
}) => {
  const { CLIENT_DATA, USER_DATA, CERTIFICATE_DATA, STORE_DATA } = FORM_FIELDS;

  const [confirmData, setConfirmData] = useState(false);
  const [confirmDataError, setConfirmDataError] = useState(null);

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const handleClose = () => {
    setModal({ show: false });
  };

  const onNextPage = () => {
    if (!confirmData) {
      setConfirmDataError("Molimo potvrdite podatke.");
      return;
    }
    setConfirmDataError(null);

    const uploadData = new FormData();

    const clientData = formData[CLIENT_DATA.name];
    Object.keys(clientData).forEach((key) => {
      if (key === CLIENT_DATA.POSTAL_NUMBER.name) {
        uploadData.append(
          [`${CLIENT_DATA.name}.${key}`],
          clientData[key]?.value
        );
        return;
      }

      if (key === CLIENT_DATA.IBAN.name) {
        uploadData.append(
          [`${CLIENT_DATA.name}.${key}`],
          "HR" + clientData[key]
        );

        return;
      }

      uploadData.append([`${CLIENT_DATA.name}.${key}`], clientData[key]);
    });

    const userData = formData[USER_DATA.name];
    Object.keys(userData).forEach((key) => {
      uploadData.append([`${USER_DATA.name}.${key}`], userData[key]);
    });

    const storeArray = formData[STORE_DATA.name];
    storeArray.forEach((storeData, index) => {
      Object.keys(storeData).forEach((key) => {
        if (key === "priceListTableData") return;

        if (key === STORE_DATA.POSTAL_NUMBER.name) {
          uploadData.append(
            [`${STORE_DATA.name}[${index}].${key}`],
            storeData[key]?.value
          );
          return;
        }

        if (key === STORE_DATA.POS_DATA.name) {
          const posArray = storeData[STORE_DATA.POS_DATA.name];
          posArray.forEach((posData, posIndex) => {
            Object.keys(posData).forEach((posKey) => {
              if (posKey === "id") return;
              if (posKey === STORE_DATA.POS_DATA.DEPOSIT.name) {
                uploadData.append(
                  [
                    `${STORE_DATA.name}[${index}].${key}[${posIndex}].${posKey}`,
                  ],
                  parseFloat(convertToDecimalString(posData[posKey]))
                );
                return;
              }
              uploadData.append(
                [`${STORE_DATA.name}[${index}].${key}[${posIndex}].${posKey}`],
                posData[posKey]
              );
            });
          });

          return;
        }

        if (key === STORE_DATA.PRICE_LIST_DATA.name) {
          const priceListArray = storeData[STORE_DATA.PRICE_LIST_DATA.name];
          priceListArray.forEach((priceListData, priceListIndex) => {
            Object.keys(priceListData).forEach((priceListKey) => {
              if (priceListKey === STORE_DATA.PRICE_LIST_DATA.FILE.name) {
                // uploadData.append(
                //   `files[${index}]`,
                //   priceListData[priceListKey]
                // );
                return;
              }

              uploadData.append(
                [
                  `${STORE_DATA.name}[${index}].${key}[${priceListIndex}].${priceListKey}`,
                ],
                priceListData[priceListKey]
              );
            });
          });

          return;
        }

        uploadData.append(
          [`${STORE_DATA.name}[${index}].${key}`],
          storeData[key]
        );
      });
    });

    const certificateData = formData[CERTIFICATE_DATA.name];
    Object.keys(certificateData).forEach((key) => {
      if (key === CERTIFICATE_DATA.FILE_CONTENT.name) {
        uploadData.append(
          [`${CERTIFICATE_DATA.name}.${key}`],
          certificateData[key]?.[0]
        );
        return;
      }
      uploadData.append(
        [`${CERTIFICATE_DATA.name}.${key}`],
        certificateData[key]
      );
    });

    tenantService
      .publicOnboadring(uploadData)
      .then((res) => {
        if (res?.data?.success) {
          resetData(res?.data?.message);
          return;
        }
        setModal({
          show: true,
          title: "Greška!",
          text: "Došlo je dogreške prilikom slanja podataka. Molimo obratite se korisničkoj podršci.",
          btnClass: "btn btn-primary",
        });
      })
      .catch(() => {
        setModal({
          show: true,
          title: "Greška!",
          text: "Došlo je dogreške prilikom slanja podataka. Molimo obratite se korisničkoj podršci.",
          btnClass: "btn btn-primary",
        });
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-md-4">
          <h6>
            <strong>Poslovni subjekt</strong>
          </h6>
          <ul className="list-group">
            <li className="list-group-item">
              <strong>{CLIENT_DATA.OIB.title}:</strong>{" "}
              {formData[CLIENT_DATA.name][CLIENT_DATA.OIB.name]}
            </li>
            <li className="list-group-item">
              <strong>{CLIENT_DATA.NAME.title}:</strong>{" "}
              {formData[CLIENT_DATA.name][CLIENT_DATA.NAME.name]}
            </li>
            <li className="list-group-item">
              <strong>{CLIENT_DATA.IBAN.title}:</strong>{" "}
              {formData[CLIENT_DATA.name][CLIENT_DATA.IBAN.name]}
            </li>
            <li className="list-group-item">
              <strong>{CLIENT_DATA.TAX_OBLIGATION.title}:</strong>{" "}
              {formData[CLIENT_DATA.name][CLIENT_DATA.TAX_OBLIGATION.name]}
            </li>
            <li className="list-group-item">
              <strong>{CLIENT_DATA.TAX_NOTE.title}:</strong>{" "}
              {formData[CLIENT_DATA.name][CLIENT_DATA.TAX_NOTE.name]}
            </li>
            <li className="list-group-item">
              <strong>{CLIENT_DATA.STREET.title}:</strong>{" "}
              {formData[CLIENT_DATA.name][CLIENT_DATA.STREET.name]}
            </li>
            <li className="list-group-item">
              <strong>{CLIENT_DATA.STREET_NUMBER.title}:</strong>{" "}
              {formData[CLIENT_DATA.name][CLIENT_DATA.STREET_NUMBER.name]}
            </li>
            <li className="list-group-item">
              <strong>{CLIENT_DATA.STREET_NUMBER_EXTENSTION.title}:</strong>{" "}
              {
                formData[CLIENT_DATA.name][
                  CLIENT_DATA.STREET_NUMBER_EXTENSTION.name
                ]
              }
            </li>
            <li className="list-group-item">
              <strong>{CLIENT_DATA.POSTAL_NUMBER.title}:</strong>{" "}
              {/* {formData[CLIENT_DATA.name][CLIENT_DATA.POSTAL_NUMBER.name]} */}
            </li>
            <li className="list-group-item">
              <strong>{CLIENT_DATA.CITY.title}:</strong>{" "}
              {formData[CLIENT_DATA.name][CLIENT_DATA.CITY.name]}
            </li>
          </ul>
        </div>
        <div className="col-md-4">
          <h6>
            <strong>{USER_DATA.title}</strong>
          </h6>
          <ul className="list-group">
            <li className="list-group-item">
              <strong>{USER_DATA.OIB.title}:</strong>{" "}
              {formData[USER_DATA.name][USER_DATA.OIB.name]}
            </li>
            <li className="list-group-item">
              <strong>{USER_DATA.FIRST_NAME.title}:</strong>{" "}
              {formData[USER_DATA.name][USER_DATA.FIRST_NAME.name]}
            </li>
            <li className="list-group-item">
              <strong>{USER_DATA.LAST_NAME.title}:</strong>{" "}
              {formData[USER_DATA.name][USER_DATA.LAST_NAME.name]}
            </li>
            <li className="list-group-item">
              <strong>{USER_DATA.PHONE.title}:</strong>{" "}
              {formData[USER_DATA.name][USER_DATA.PHONE.name]}
            </li>
            <li className="list-group-item">
              <strong>{USER_DATA.EMAIL.title}:</strong>{" "}
              {formData[USER_DATA.name][USER_DATA.EMAIL.name]}
            </li>
            <li className="list-group-item">
              <strong>{USER_DATA.PIN.title}:</strong>{" "}
              {formData[USER_DATA.name][USER_DATA.PIN.name]}
            </li>
            <li className="list-group-item">
              <strong>
                <center>Dodatni blagajnik</center>
              </strong>
            </li>
            <li className="list-group-item">
              <strong>{USER_DATA.ADDITIONAL_OIB.title}:</strong>{" "}
              {formData[USER_DATA.name][USER_DATA.ADDITIONAL_OIB.name]}
            </li>
            <li className="list-group-item">
              <strong>{USER_DATA.ADDITIONAL_FIRST_NAME.title}:</strong>{" "}
              {formData[USER_DATA.name][USER_DATA.ADDITIONAL_FIRST_NAME.name]}
            </li>
            <li className="list-group-item">
              <strong>{USER_DATA.ADDITIONAL_LAST_NAME.title}:</strong>{" "}
              {formData[USER_DATA.name][USER_DATA.ADDITIONAL_LAST_NAME.name]}
            </li>
            <li className="list-group-item">
              <strong>{USER_DATA.ADDITIONAL_PIN.title}:</strong>{" "}
              {formData[USER_DATA.name][USER_DATA.ADDITIONAL_PIN.name]}
            </li>
          </ul>
        </div>
        <div className="col-md-4">
          <h6>
            <strong>{CERTIFICATE_DATA.title}</strong>
          </h6>
          <ul className="list-group">
            <li className="list-group-item">
              <strong>{CERTIFICATE_DATA.CERT_PASSWORD.title}:</strong>{" "}
              {
                formData[CERTIFICATE_DATA.name]?.[
                  CERTIFICATE_DATA.CERT_PASSWORD.name
                ]
              }
            </li>
          </ul>
        </div>
        <div className="col-12 mt-4">
          <h6>
            <strong>{STORE_DATA.title}</strong>
          </h6>
          <StoresPreveiwList stores={formData[STORE_DATA.name]} />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <p>
            Došli ste do kraja forme. Unesene podatke možete pregledati i
            mijenjati klikom na gumb "Povratak".Nakon pregledavanja svih
            unesenih podataka molimo Vas potvrdite da su točno upisani. Klikom
            na gumb "Sljedeći korak" unesene informacije će biti poslale i
            prikazat će se na sljedećoj stranici.
          </p>
        </div>
      </div>
      <div className="form-group">
        <label className="labelCont">
          <input
            type="checkbox"
            checked={confirmData}
            onChange={() => {
              setConfirmData((x) => !x);
            }}
          />
          <span className="checkmark"></span>
        </label>
        <span>Potvrđujem podatke *</span>
        {/* <Tooltip text="Ukoliko nema porezne obveze, portebno je odznačiti ovo polje. U slučaju promjene u poreznoj obvezi, polje je moguće naknadno ažurirati." /> */}
      </div>
      <p className="text-danger">{confirmDataError}</p>
      <Stepper
        stepState={stepState}
        previousPage={previousPage}
        nextPage={onNextPage}
      />
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        closeBtnText="Zatvori"
        handleClose={handleClose}
      />
    </>
  );
};

export default DataVerification;
